import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-100 w-sm-50 px-5 px-sm-0 mt-20"
}
const _hoisted_2 = { class: "mb-10 text-center" }
const _hoisted_3 = { class: "text-dark mb-3" }
const _hoisted_4 = { class: "text-gray-400 fw-bold fs-4" }
const _hoisted_5 = { class: "d-flex align-items-center mb-10" }
const _hoisted_6 = { class: "fw-light fs-7 mx-2 text-uppercase" }
const _hoisted_7 = { class: "fv-row mb-7" }
const _hoisted_8 = {
  for: "p_iva",
  class: "form-label fw-bolder text-dark fs-6"
}
const _hoisted_9 = { class: "fv-plugins-message-container" }
const _hoisted_10 = { class: "fv-help-block" }
const _hoisted_11 = { class: "fv-row mb-7" }
const _hoisted_12 = {
  for: "denom",
  class: "form-label fw-bolder text-dark fs-6"
}
const _hoisted_13 = { class: "fv-plugins-message-container" }
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { class: "fv-row mb-7" }
const _hoisted_16 = {
  for: "settore",
  class: "form-label fw-bolder text-dark fs-6"
}
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "fv-plugins-message-container" }
const _hoisted_19 = { class: "fv-help-block" }
const _hoisted_20 = { class: "fv-row mb-7" }
const _hoisted_21 = {
  for: "employee_range",
  class: "form-label fw-bolder text-dark fs-6"
}
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "fv-plugins-message-container" }
const _hoisted_24 = { class: "fv-help-block" }
const _hoisted_25 = { class: "fv-row mb-7" }
const _hoisted_26 = {
  for: "fatturati",
  class: "form-label fw-bolder text-dark fs-6"
}
const _hoisted_27 = ["value"]
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "fv-plugins-message-container" }
const _hoisted_31 = { class: "fv-help-block" }
const _hoisted_32 = { class: "fv-row mb-7" }
const _hoisted_33 = {
  for: "user_name",
  class: "form-label fw-bolder text-dark fs-6"
}
const _hoisted_34 = { class: "fv-plugins-message-container" }
const _hoisted_35 = { class: "fv-help-block" }
const _hoisted_36 = { class: "row fv-row mb-7" }
const _hoisted_37 = { class: "col-xl-6" }
const _hoisted_38 = {
  for: "email",
  class: "form-label fw-bolder text-dark fs-6"
}
const _hoisted_39 = { class: "fv-plugins-message-container" }
const _hoisted_40 = { class: "fv-help-block" }
const _hoisted_41 = { class: "col-xl-6" }
const _hoisted_42 = {
  for: "email_confirmation",
  class: "form-label fw-bolder text-dark fs-6"
}
const _hoisted_43 = { class: "fv-plugins-message-container" }
const _hoisted_44 = { class: "fv-help-block" }
const _hoisted_45 = {
  class: "mb-10 fv-row",
  "data-kt-password-meter": "true"
}
const _hoisted_46 = { class: "mb-1" }
const _hoisted_47 = { class: "position-relative mb-3" }
const _hoisted_48 = { class: "fv-plugins-message-container" }
const _hoisted_49 = { class: "fv-help-block" }
const _hoisted_50 = { class: "fv-row mb-5" }
const _hoisted_51 = {
  for: "password_confirmation",
  class: "form-label fw-bolder text-dark fs-6"
}
const _hoisted_52 = { class: "fv-plugins-message-container" }
const _hoisted_53 = { class: "fv-help-block" }
const _hoisted_54 = { class: "fv-row mb-5" }
const _hoisted_55 = {
  for: "role",
  class: "form-label fw-bolder text-dark fs-6"
}
const _hoisted_56 = { class: "fv-plugins-message-container" }
const _hoisted_57 = { class: "fv-help-block" }
const _hoisted_58 = { class: "fv-row mb-5" }
const _hoisted_59 = {
  for: "tel",
  class: "form-label fw-bolder text-dark fs-6"
}
const _hoisted_60 = { class: "fv-plugins-message-container" }
const _hoisted_61 = { class: "fv-help-block" }
const _hoisted_62 = { class: "fv-row mb-5" }
const _hoisted_63 = { class: "form-label fw-bolder text-dark fs-6" }
const _hoisted_64 = { class: "d-flex align-items-center mt-3" }
const _hoisted_65 = {
  for: "associated",
  class: "form-check form-check-inline form-check-solid me-5"
}
const _hoisted_66 = { class: "fw-bold ps-2 fs-6 first_letter_upper" }
const _hoisted_67 = {
  for: "notAssociated",
  class: "form-check form-check-inline form-check-solid"
}
const _hoisted_68 = { class: "fw-bold ps-2 fs-6 first_letter_upper" }
const _hoisted_69 = { class: "fv-plugins-message-container" }
const _hoisted_70 = { class: "fv-help-block" }
const _hoisted_71 = { class: "fv-row mb-5" }
const _hoisted_72 = { class: "form-label fw-bolder text-dark fs-6" }
const _hoisted_73 = { class: "d-flex align-items-center mt-3" }
const _hoisted_74 = {
  for: "currentIsQuotedTrue",
  class: "form-check form-check-inline form-check-solid me-5"
}
const _hoisted_75 = { class: "fw-bold ps-2 fs-6 first_letter_upper" }
const _hoisted_76 = {
  for: "currentIsQuotedFalse",
  class: "form-check form-check-inline form-check-solid"
}
const _hoisted_77 = { class: "fw-bold ps-2 fs-6 first_letter_upper" }
const _hoisted_78 = { class: "fv-plugins-message-container" }
const _hoisted_79 = { class: "fv-help-block" }
const _hoisted_80 = { class: "fv-row mb-5" }
const _hoisted_81 = { class: "form-label fw-bolder text-dark fs-6" }
const _hoisted_82 = { class: "mt-3" }
const _hoisted_83 = {
  for: "company_type_d01",
  class: "form-check form-check form-check-solid mt-3"
}
const _hoisted_84 = { class: "fw-bold ps-2 fs-6" }
const _hoisted_85 = {
  for: "company_type_d02",
  class: "form-check form-check form-check-solid mt-3"
}
const _hoisted_86 = { class: "fw-bold ps-2 fs-6 first_letter_upper" }
const _hoisted_87 = {
  for: "company_type_d03",
  class: "form-check form-check form-check-solid mt-3"
}
const _hoisted_88 = { class: "fw-bold ps-2 fs-6 first_letter_upper" }
const _hoisted_89 = { class: "fv-plugins-message-container" }
const _hoisted_90 = { class: "fv-help-block" }
const _hoisted_91 = { class: "fv-row mb-10" }
const _hoisted_92 = {
  for: "agree",
  class: "form-check form-check-custom form-check-solid"
}
const _hoisted_93 = { class: "form-check-label fw-bold text-gray-700 fs-6" }
const _hoisted_94 = { class: "fv-plugins-message-container" }
const _hoisted_95 = { class: "fv-help-block" }
const _hoisted_96 = { class: "text-center" }
const _hoisted_97 = {
  id: "kt_sign_up_submit",
  ref: "submitButton",
  type: "submit",
  class: "btn-request-account btn btn-lg btn-dark-blue"
}
const _hoisted_98 = { class: "indicator-label" }
const _hoisted_99 = { class: "indicator-progress" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.selectLists)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Form, {
          class: "form fv-plugins-bootstrap5 fv-plugins-framework mx-auto",
          novalidate: "novalidate",
          onSubmit: _ctx.onSubmitRegister,
          id: "kt_login_signup_form",
          "validation-schema": _ctx.registration
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.translate("REGISTRATION_MAIN_HEADER")), 1),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_router_link, {
                  to: "/sign-in",
                  class: "link-primary fw-bolder"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.translate("LOGIN_BACK_TO_HOME_MESSAGE")), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "border-bottom border-gray-300 mw-50 w-100" }, null, -1)),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.translate("OR_LABEL")), 1),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "border-bottom border-gray-300 mw-50 w-100" }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate("REGISTRATION_P_IVA_PLACEHOLDER")) + " *", 1),
              _createVNode(_component_Field, {
                class: "form-control form-control-lg",
                type: "text",
                placeholder: _ctx.translate('REGISTRATION_P_IVA_INVALID'),
                name: "p_iva",
                id: "p_iva",
                "aria-describedby": "p_iva_error",
                autocomplete: "off"
              }, null, 8, ["placeholder"]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_ErrorMessage, {
                    name: "p_iva",
                    id: "p_iva_error"
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.translate("REGISTRATION_DENOMINATION_PLACEHOLDER")) + " *", 1),
              _createVNode(_component_Field, {
                class: "form-control form-control-lg",
                type: "text",
                placeholder: _ctx.translate('REGISTRATION_DENOM_INVALID'),
                name: "denom",
                id: "denom",
                "aria-describedby": "denom_error",
                autocomplete: "off"
              }, null, 8, ["placeholder"]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_ErrorMessage, {
                    name: "denom",
                    id: "denom_error"
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.translate("REGISTRATION_INDUSTRIAL_SECTOR_MESSAGE")) + " *", 1),
              _createVNode(_component_Field, {
                class: "form-control form-control-lg",
                as: "select",
                placeholder: "",
                name: "settore",
                id: "settore",
                "aria-describedby": "settore_error",
                autocomplete: "off"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectLists.settori, (item, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: item.id,
                      key: index
                    }, _toDisplayString(item[_ctx.translateKey("descrizione")]), 9, _hoisted_17))
                  }), 128))
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_ErrorMessage, {
                    name: "settore",
                    id: "settore_error"
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.translate("REGISTRATION_EMPLOYEE_RANGE_MESSAGE")) + " *", 1),
              _createVNode(_component_Field, {
                class: "form-control form-control-lg",
                as: "select",
                placeholder: "",
                name: "employee_range",
                id: "employee_range",
                "aria-describedby": "employee_range_error",
                autocomplete: "off"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectLists.employee_range, (item, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: item.range_id,
                      key: index
                    }, _toDisplayString(item.description), 9, _hoisted_22))
                  }), 128))
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_ErrorMessage, {
                    name: "employee_range",
                    id: "employee_range_error"
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.translate("REGISTRATION_REVENUE_RANGE_MESSAGE")) + " *", 1),
              _createVNode(_component_Field, {
                class: "form-control form-control-lg",
                as: "select",
                placeholder: "",
                name: "fatturati",
                id: "fatturati",
                "aria-describedby": "fatturati_error",
                autocomplete: "off"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectLists.fatturati, (item, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: item.id,
                      key: index
                    }, [
                      (_ctx.locale === 'it')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(item.descrizione), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(item.descrizione_en), 1))
                    ], 8, _hoisted_27))
                  }), 128))
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_ErrorMessage, {
                    name: "fatturati",
                    id: "fatturati_error"
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.translate("REGISTRATION_USERNAME")) + " *", 1),
              _createVNode(_component_Field, {
                class: "form-control form-control-lg",
                type: "string",
                placeholder: _ctx.translate('REGISTRATION_USERNAME_PLACEHOLDER'),
                name: "user_name",
                id: "user_name",
                "aria-describedby": "user_name_error",
                autocomplete: "off"
              }, null, 8, ["placeholder"]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_component_ErrorMessage, {
                    name: "user_name",
                    id: "user_name_error"
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.translate("REGISTRATION_EMAIL")) + " *", 1),
                _createVNode(_component_Field, {
                  class: "form-control form-control-lg",
                  type: "email",
                  placeholder: _ctx.translate('REGISTRATION_EMAIL_PLACEHOLDER'),
                  name: "email",
                  id: "email",
                  "aria-describedby": "email_error",
                  autocomplete: "off"
                }, null, 8, ["placeholder"]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(_component_ErrorMessage, {
                      name: "email",
                      id: "email_error"
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.translate("REGISTRATION_EMAIL_REPEAT_PLACEHOLDER")) + " *", 1),
                _createVNode(_component_Field, {
                  class: "form-control form-control-lg",
                  type: "email",
                  placeholder: "",
                  name: "email_confirmation",
                  id: "email_confirmation",
                  "aria-describedby": "email_confirmation_error",
                  autocomplete: "off"
                }),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _createVNode(_component_ErrorMessage, {
                      name: "email_confirmation",
                      id: "email_confirmation_error"
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _cache[2] || (_cache[2] = _createElementVNode("label", {
                  for: "password",
                  class: "form-label fw-bolder text-dark fs-6"
                }, " Password *", -1)),
                _createElementVNode("div", _hoisted_47, [
                  _createVNode(_component_Field, {
                    class: "form-control form-control-lg",
                    type: "password",
                    placeholder: _ctx.translate('REGISTRATION_PASSWORD_PLACEHOLDER'),
                    name: "password",
                    id: "password",
                    "aria-describedby": "password_error",
                    autocomplete: "off"
                  }, null, 8, ["placeholder"]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createVNode(_component_ErrorMessage, {
                        name: "password",
                        id: "password_error"
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.translate("REGISTRATION_PASSWORD_REPEAT_PLACEHOLDER")) + " * ", 1),
              _createVNode(_component_Field, {
                class: "form-control form-control-lg",
                type: "password",
                placeholder: "",
                name: "password_confirmation",
                id: "password_confirmation",
                "aria-describedby": "password_confirmation_error",
                autocomplete: "off"
              }),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _createVNode(_component_ErrorMessage, {
                    name: "password_confirmation",
                    id: "password_confirmation_error"
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.translate("REGISTRATION_ROLE_PLACEHOLDER")), 1),
              _createVNode(_component_Field, {
                class: "form-control form-control-lg",
                type: "text",
                placeholder: _ctx.translate('REGISTRATION_ROLE_INVALID'),
                name: "role",
                id: "role",
                "aria-describedby": "role_error",
                autocomplete: "off"
              }, null, 8, ["placeholder"]),
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _createVNode(_component_ErrorMessage, {
                    name: "role",
                    id: "role_error"
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.translate("REGISTRATION_PHONE")), 1),
              _createVNode(_component_Field, {
                class: "form-control form-control-lg",
                type: "number",
                placeholder: _ctx.translate('REGISTRATION_PHONE_PLACEHOLDER'),
                name: "tel",
                id: "tel",
                "aria-describedby": "tel_error",
                autocomplete: "off"
              }, null, 8, ["placeholder"]),
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _createVNode(_component_ErrorMessage, {
                    name: "tel",
                    id: "tel_error"
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.translate("REGISTRATION_AZIENDA_IS_ASSOCIATED_LABEL")) + " * ", 1),
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("label", _hoisted_65, [
                  _createVNode(_component_Field, {
                    class: "form-check-input",
                    name: "currentIsAssociated",
                    id: "associated",
                    "aria-describedby": "associated_error",
                    type: "radio",
                    value: "1"
                  }),
                  _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.translate("CHANGE_ASSOCIATED_OPTION")), 1)
                ]),
                _createElementVNode("label", _hoisted_67, [
                  _createVNode(_component_Field, {
                    class: "form-check-input",
                    name: "currentIsAssociated",
                    id: "notAssociated",
                    "aria-describedby": "associated_error",
                    type: "radio",
                    value: "0"
                  }),
                  _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.translate("CHANGE_NOT_ASSOCIATED_OPTION")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, [
                  _createVNode(_component_ErrorMessage, {
                    name: "currentIsAssociated",
                    id: "associated_error"
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.translate("REGISTRATION_AZIENDA_IS_QUOTED_LABEL")) + " * ", 1),
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("label", _hoisted_74, [
                  _createVNode(_component_Field, {
                    class: "form-check-input",
                    name: "currentIsQuoted",
                    id: "currentIsQuotedTrue",
                    "aria-describedby": "current_is_quoted_error",
                    type: "radio",
                    value: "1"
                  }),
                  _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.translate("CHANGE_QUOTED_OPTION")), 1)
                ]),
                _createElementVNode("label", _hoisted_76, [
                  _createVNode(_component_Field, {
                    class: "form-check-input",
                    name: "currentIsQuoted",
                    id: "currentIsQuotedFalse",
                    "aria-describedby": "current_is_quoted_error",
                    type: "radio",
                    value: "0"
                  }),
                  _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.translate("CHANGE_NOT_QUOTED_OPTION")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("div", _hoisted_79, [
                  _createVNode(_component_ErrorMessage, {
                    name: "currentIsQuoted",
                    id: "current_is_quoted_error"
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_80, [
              _createElementVNode("div", _hoisted_81, _toDisplayString(_ctx.translate("REGISTRATION_COMPANY_TYPE_LABEL")) + " * ", 1),
              _createElementVNode("div", _hoisted_82, [
                _createElementVNode("label", _hoisted_83, [
                  _createVNode(_component_Field, {
                    class: "form-check-input",
                    name: "company_type",
                    id: "company_type_d01",
                    "aria-describedby": "company_type_error",
                    value: "D01",
                    type: "radio"
                  }),
                  _createElementVNode("span", _hoisted_84, _toDisplayString(_ctx.translate("REGISTRATION_CHANGE_PMI_OPTION")), 1)
                ]),
                _createElementVNode("label", _hoisted_85, [
                  _createVNode(_component_Field, {
                    class: "form-check-input",
                    name: "company_type",
                    id: "company_type_d02",
                    "aria-describedby": "company_type_error",
                    value: "D02",
                    type: "radio"
                  }),
                  _createElementVNode("span", _hoisted_86, _toDisplayString(_ctx.translate("CHANGE_SMALL_OPTION")), 1)
                ]),
                _createElementVNode("label", _hoisted_87, [
                  _createVNode(_component_Field, {
                    class: "form-check-input",
                    name: "company_type",
                    value: "D03",
                    id: "company_type_d03",
                    "aria-describedby": "company_type_error",
                    type: "radio"
                  }),
                  _createElementVNode("span", _hoisted_88, _toDisplayString(_ctx.translate("CHANGE_LARGE_OPTION")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_89, [
                _createElementVNode("div", _hoisted_90, [
                  _createVNode(_component_ErrorMessage, {
                    name: "company_type",
                    id: "company_type_error"
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_91, [
              _createElementVNode("label", _hoisted_92, [
                _createVNode(_component_Field, {
                  class: "form-check-input",
                  type: "checkbox",
                  name: "agree",
                  id: "agree",
                  "aria-describedby": "agree_error",
                  value: "1"
                }),
                _createElementVNode("span", _hoisted_93, [
                  (_ctx.locale == 'it')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[3] || (_cache[3] = _createTextVNode(" Accetto i ", -1)),
                        _cache[4] || (_cache[4] = _createElementVNode("a", {
                          href: "https://valored.it/informativa_iii_ita",
                          target: "_blank",
                          style: {"color":"#000000"}
                        }, [
                          _createElementVNode("u", null, "termini di privacy")
                        ], -1)),
                        _cache[5] || (_cache[5] = _createTextVNode(" ai sensi del Regolamento (UE) 2016/679. ", -1))
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _cache[6] || (_cache[6] = _createTextVNode(" I have read and accept the ", -1)),
                        _cache[7] || (_cache[7] = _createElementVNode("a", {
                          href: "https://valored.it/informativa_iii_eng",
                          target: "_blank",
                          style: {"color":"#000000"}
                        }, [
                          _createElementVNode("u", null, "personal data agreement")
                        ], -1)),
                        _cache[8] || (_cache[8] = _createTextVNode(" according to the Regulation (EU) 2016/679. ", -1))
                      ], 64))
                ])
              ]),
              _createElementVNode("div", _hoisted_94, [
                _createElementVNode("div", _hoisted_95, [
                  _createVNode(_component_ErrorMessage, {
                    name: "agree",
                    id: "agree_error"
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_96, [
              _createElementVNode("button", _hoisted_97, [
                _createElementVNode("span", _hoisted_98, _toDisplayString(_ctx.translate("REGISTRATION_SUBMIT_BUTTON")), 1),
                _createElementVNode("span", _hoisted_99, [
                  _createTextVNode(_toDisplayString(_ctx.translate("BUTTON_WAIT")) + " ", 1),
                  _cache[9] || (_cache[9] = _createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
                ])
              ], 512)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ]))
    : _createCommentVNode("", true)
}